import React from "react";

type ViewOnlyProps = React.SVGProps<SVGSVGElement>;

const ViewOnly = (props: ViewOnlyProps) => {
    return (
        <svg
            id="view-only-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 182.11 234.54"
            {...props}
        >
            <defs>
                <mask
                    id="view-only-mask"
                    x="11.63"
                    y="54.9"
                    width="159.02"
                    height="159.02"
                    maskUnits="userSpaceOnUse"
                >
                    <g id="view-only-mask-circle">
                        <circle
                            fill="#fff"
                            cx="91.13"
                            cy="134.41"
                            r="79.51"
                            colorRendering="auto"
                            imageRendering="auto"
                            shapeRendering="auto"
                        />
                    </g>
                </mask>
            </defs>

            <path
                fill="#c12906"
                fillRule="evenodd"
                d="M182.1,70.66v149.97c0,7.69-7.67,13.91-17.14,13.91H17.14c-9.47,0-17.14-6.22-17.14-13.91V17.14C0,7.67,7.67,0,17.14,0h94.31l70.65,70.66Z"
            />

            <path
                fill="#9b0d0a"
                fillRule="evenodd"
                d="M111.41,0h.03l70.67,70.67h-52.86c-4.73,0-9.27-1.88-12.61-5.23s-5.23-7.88-5.23-12.61V0h0Z"
            />

            <g mask="url(#view-only-mask)">
                <path
                    fill="#fff"
                    colorRendering="auto"
                    imageRendering="auto"
                    shapeRendering="auto"
                    d="M90.72,105.57c-18.29.04-37.01,8.43-56.22,26.57,37.75,44.37,75.51,40.41,113.26,0-18.03-16.67-36.42-26.04-55.28-26.55-.59-.02-1.18-.02-1.77-.02h0ZM90.84,113.59c.43,0,.86,0,1.28.02,13.68.37,27.02,7.17,40.1,19.26-27.39,29.31-54.78,32.19-82.17,0,13.94-13.16,27.52-19.25,40.79-19.28h0ZM91.28,117.95c-9.4,0-17.02,7.62-17.02,17.02h0c0,9.4,7.62,17.03,17.02,17.03h0c9.4,0,17.02-7.62,17.03-17.02h0c0-1.42-.19-2.83-.54-4.21l-16.48,4.21s7.11-9.87,10-13.76c-2.9-2.12-6.4-3.26-10-3.27h0Z"
                />
            </g>
        </svg>
    );
};

export default ViewOnly;